export enum TvDisplayModeEnum {
    DEFAULT = 'DEFAULT',
    WELCOME = 'WELCOME',
}
